import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Case } from '../../../../types/Case/Case.type';
import { GridCaseItem } from './GridCaseItem';

interface GridViewProps {
  activeSort: string;
  cases: Case[];
  fetchNextPage: () => void;
  loadingNextPage: boolean;
  hasNextPage: boolean;
}

export const GridView = ({ activeSort, cases, fetchNextPage, loadingNextPage, hasNextPage }: GridViewProps) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && fetchNextPage && !loadingNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, loadingNextPage]);

  return (
    <div style={{ overflowY: 'auto', maxHeight: '620px', minHeight: '620px', marginTop: '32px', marginBottom: '32px' }}>
      <Grid
        container
        sx={{
          columnGap: 4,
          rowGap: 4,
        }}
      >
        {cases?.map((caseData) => (
          <GridCaseItem key={caseData.id} caseData={caseData} activeSort={activeSort} />
        ))}
        {hasNextPage && <div ref={ref} style={{ height: '1px', width: '100%' }}></div>}
      </Grid>
      {loadingNextPage && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
          <Typography
            variant='caption'
            sx={{
              color: '#a0aec0',
            }}
          >
            Loading more cases...
          </Typography>
        </div>
      )}
    </div>
  );
};
